import React, {FC} from "react"

import Card from "@irati/ui/src/Layout/Card"
import {UserSavings} from "@irati/adminReporting/services/adminReporting"
import Flex from "@irati/ui/src/Flex"

import Balance from "../MySavingsCard/Balance"
import Breakdown from "../MySavingsCard/Breakdown"
import SaveWith from "../MySavingsCard/SaveWith"

interface Props {
  data: UserSavings
}

const MySavingsWidget: FC<Props> = ({data}) => {
  return (
    <Card>
      <Flex alignItems="center" wrap="wrap">
        <div style={{flex: 1}}>
          <Balance savings={data.savings} previousSavings={data.previousSavings} showIcon={false} />
        </div>
        <div style={{flex: 2}}>
          <SaveWith savings={data.savings} />
          <Breakdown savings={data.savings} showBreakdownDetails />
        </div>
      </Flex>
    </Card>
  )
}

export default MySavingsWidget
